import { get } from 'lodash-es';

export const mapifyPayload = <T extends { id: string }>(data: T[], key: keyof T = 'id'): Record<string, T> =>
  data.reduce(
    (acc, current) => ({
      ...acc,
      [get(current, key) as string]: current,
    }),
    {},
  );
